import { api } from "@/lib/api";

export interface ProjectCredential {
  _id: string;
  projectId: string;
  permitSubmittalLink?: string;
  notes?: string;
  createdBy: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  updatedBy: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CreateCredentialRequest {
  permitSubmittalLink?: string;
  username?: string;
  password?: string;
  notes?: string;
}

export interface UpdateCredentialRequest {
  permitSubmittalLink?: string;
  username?: string;
  password?: string;
  notes?: string;
}

export interface CredentialValueResponse {
  username?: string;
  password?: string;
}

export interface CredentialsResponse {
  success: boolean;
  data: ProjectCredential | null;
}

export interface CredentialResponse {
  success: boolean;
  data: ProjectCredential;
  message?: string;
}

export interface CredentialValueRevealResponse {
  success: boolean;
  data: CredentialValueResponse;
}

export interface CredentialDeleteResponse {
  success: boolean;
  message: string;
}

export const credentialsApi = {
  /**
   * Get credentials for a project (admin only)
   */
  getProjectCredentials: async (projectId: string): Promise<CredentialsResponse> => {
    const response = await api.get(`/projects/${projectId}/credentials`);
    return response.data;
  },

  /**
   * Create or update credentials for a project (admin only)
   */
  createOrUpdateCredential: async (
    projectId: string,
    credential: CreateCredentialRequest
  ): Promise<CredentialResponse> => {
    const response = await api.post(`/projects/${projectId}/credentials`, credential);
    return response.data;
  },

  /**
   * Reveal (decrypt) the username (admin only)
   */
  revealCredentialUsername: async (
    projectId: string
  ): Promise<CredentialValueRevealResponse> => {
    const response = await api.get(`/projects/${projectId}/credentials/reveal-username`);
    return response.data;
  },

  /**
   * Reveal (decrypt) the password (admin only)
   */
  revealCredentialPassword: async (
    projectId: string
  ): Promise<CredentialValueRevealResponse> => {
    const response = await api.get(`/projects/${projectId}/credentials/reveal-password`);
    return response.data;
  },

  /**
   * Update credentials (admin only)
   */
  updateCredential: async (
    projectId: string,
    updates: UpdateCredentialRequest
  ): Promise<CredentialResponse> => {
    const response = await api.put(`/projects/${projectId}/credentials`, updates);
    return response.data;
  },

  /**
   * Delete credentials (admin only)
   */
  deleteCredential: async (
    projectId: string
  ): Promise<CredentialDeleteResponse> => {
    const response = await api.delete(`/projects/${projectId}/credentials`);
    return response.data;
  },
};
